export default {
  fr: {
    home: {
      eventlist1: "Événements dans la zone d'étude (7 derniers jours)",
      eventlist2: 'Temps en heure locale (America/Port-au-Prince)',
      infoTitle: 'Informations complémentaires',
      info1_1: "Les localisations automatiques apparaissent sous la forme d'un carré en pointillé. Dès qu'un sismologue (actuellement les sismologues du laboratoire",
      info1_2: ") a validé le séisme, la localisation apparait sous la forme d'un cercle.",
      info2: 'Les événements reportés sont ceux qui sont vus par le réseau. Hors du rectangle couvrant Haïti, les solutions peuvent être très approximatives et il vaut mieux se reporter aux organismes nationaux voisins en particulier pour St Domingue.',
      info3_1: 'Les données analysées en temps réel',
      info3_2: 'sont obtenues à partir des stations sismologiques de plusieurs réseaux : le réseau du projet S2RHAI (réseau de stations',
      info3_3: 'installées chez des particuliers ou dans des écoles), le réseau du',
      info3_4: "d'Haïti et les réseaux des pays proches (Cuba, République Dominicaine, Jamaïque, Puerto Rico). Le logiciel de détection automatique est",
      info3_5: 'développé à',
      info3_6: 'et par la société',
      info5_1: "Ayiti-Séismes est le résultat d'une collaboration entre le laboratoire URGéo de la Faculté des Sciences, le Bureau des Mines et de l'Énergie d'Haïti, le laboratoire Géoazur de l'Université Côte d'Azur (France), le laboratoire de Géologie de l'École Normale Supérieure (Paris, France), le Centre Sismologique Euro-Méditérranéen (CSEM/EMSC), et le laboratoire LAM (Les Afriques dans le Monde, CNRS/Sciences Po Bordeaux).",
      info5_2: "Ayiti-Séismes est soutenu financièrement par les projets  S2RHAI (CNRS - IRD), OSMOSE (Agence Nationale de la Recherche), CARIBACT (Laboratoire Mixte International, IRD), PREST (Interreg V Caraïbe, Union Européenne), et par l'USAID/USGS.",
      info6_1: "Ce site, actuellement hébergé à Géoazur, utilise les stations sismologiques du Bureau des Mines et de l'Energie, celles des pays voisins, ainsi que des stations sismologiques “citoyennes” Raspberry Shake (voir ",
      info6_2: ") pour localiser rapidement les séismes en Haïti et dans ses environs. Il permet donc à tout un chacun de visualiser l'activité sismique en Haïti en temps quasi-réel.",
      info7: "Cette information rapide reste néanmoins préliminaire. L'information officielle pour Haïti est fournie par le bulletin du Bureau des Mines et de l'Energie."
    },
    nav: {
      home: 'Accueil',
      scientificData: 'Données scientifiques',
      catalog: 'Catalogue',
      scientificalResults: 'Résultats scientifiques',
      fdsnws: 'Webservices FDSN',
      station: 'Stations',
      info: 'Informations',
      links: 'Liens'
    },
    app: {
      geolocationTitle: 'Géolocalisation',
      geolocationContent1: "Activer la géolocalisation permet de bénéficier d'outils supplémentaires :",
      geolocationContent2: 'lister les événements en fonction de votre position',
      geolocationContent3: 'lister les stations en fonction de votre position',
      geolocationContent4: "Aucune donnée personnelle n'est communiquée sur le serveur.",
      yes: 'Oui',
      no: 'Non',
      days: 'j',
      hours: 'h',
      minutes: 'm',
      seconds: 's'
    },
    event: {
      text1: 'Type',
      text2: 'Magnitude',
      text3: 'Date et heure',
      text4: 'Latitude',
      text5: 'Longitude',
      text6: 'Profondeur',
      text7: 'Carte',
      text8: 'Bulletin',
      text9: 'Stats',
      text10: 'Sismogrammes',
      text11: 'Les données sismologiques distribuées ici sont au format SAC.',
      text12: 'Une authentification est requise pour leur téléchargement.',
      text13: 'Télécharger les données'
    },
    catalog: {
      warn1: 'Les champs sont réglés comme votre dernière requête. Vous pouvez revenir à la requête par défaut en cliquant',
      warn2: 'ici',
      form1: 'Dates',
      form2: 'Derniers jours',
      form3: 'Début',
      form4: 'Fin',
      form5: 'Zone géographique',
      form6: 'min',
      form7: 'max',
      form8: 'Latitude',
      form9: 'Longitude',
      form10: "Type(s) d'événement",
      form11: 'tous les types',
      form12: 'séisme',
      form13: 'tir de carrière',
      form14: 'explosion',
      form15: 'indéfini',
      form16: 'Profondeur',
      form17: 'Magnitude',
      form18: 'Format de sortie',
      form19: 'Envoyer',
      resultNav1: 'Liste',
      resultNav2: 'Carte',
      resultNav3: 'Stats',
      resultList1: 'Résultats :',
      resultList2: 'événements',
      result0: 'Paramètres de recherche',
      result1: 'minimale',
      result2: 'maximale'
    },
    map: {
      legend0: 'Légende',
      legend1: 'Magnitude',
      legend2: "Évaluation de l'événement",
      legend3_1: 'automatique',
      legend3_2: 'Événement détecté automatiquement, pas encore confirmé par le service sismologique.',
      legend4_1: 'séisme',
      legend4_2: "L'événement est un séisme, confirmé par le service sismologique.",
      legend5_1: 'artificiel',
      legend5_2: "Événement d'origine anthropique, confirmé par le service sismologique.",
      disclaimer: 'La détection est automatique, et pas nécessairement validée par un sismologue.'
    },
    station: {
      list1: 'Latence',
      list2: 'stations avec dayplot',
      list3: 'latence',
      panel1: 'Latitude',
      panel2: 'Longitude',
      panel3: 'Altitude',
      panel4: 'Carte',
      panel5: 'Derniers séismes',
      panel6: "Date d'installation",
      map1: 'Légende',
      map2: 'Latence'
    },
    links: {
      text1: 'Liens',
      text2: 'Les partenaires principaux',
      text3: "Le projet S2RHAIL est financé par le CNRS et l'IRD (action conjointe Risques naturels).",
      text4: "Unité de Recherche en Géosciences, Faculté des Sciences de l'Université d'État d'Haïti",
      text5: "Géoazur (environ 170 personnes)  est un laboratoire de recherche en Géosciences qui dépend de l'Université Côte d'Azur, du CNRS (Centre National de la Recherche Scientifique), de l'IRD (Institut de Recherche pour le Développement) et de l'Observatoire de la Côte d'Azur. L'Observatoire Sismologique du laboratoire est en charge des données sismologiques produites dans le quart Sud-Est de la France dans le cadre du projet RESIF (Réseau Sismologique et géodésique Français). L'équipe SEISMES comprend 16 chercheurs permanents et 18 doctorants et post-doctorants qui mènent des recherches de pointe sur la compréhension des processus à l'origine des séismes et sur les mouvements du sol qu'ils engendrent en surface.",
      text6: 'Autres partenaires du projet',
      text7: "Bureau des Mines et de l'Énergie d'Haïti",
      text8: 'CSEM-EMSC, Centre Sismologique Euro-Méditerranéen',
      text9: 'Focalisé sur le bassin méditérranéen, ce site offre aussi le suivi de la sismicité mondiale',
      text10: 'Département des Géosciences, ENS, PSL',
      text11: "Le Département de Géosciences de l'Ecole normale supérieure (120 permanents) est un lieu de recherche et d'enseignement de haut niveau en sciences de la planète adossé au Laboratoire de Géologie et au Laboratoire de Météorologie Dynamique. Il forme des chercheurs en sciences de la terre, de l'océan, de l'atmosphère et en biogéosciences. L'Ecole normale supérieure est partenaire de l'Université PSL.",
      text12: "EDUMED (Université Côte d'Azur)",
      text13: "EDUMED-Obs est une interface permettant d'accéder à des données de recherche en géosciences, et orientée vers l'éducation au risque naturel pour le grand public et les scolaires. Cet observatoire éducatif vise aussi à faciliter l'utilisation des données issues de capteurs dans l'enseignement secondaire et supérieur. Les données des stations installées en Haïti sont accessibles sous",
      text14: "Formation de master en urbanisme, aménagement des territoires à risque (Faculté des Sciences de l'Université d'État d'Haïti).",
      text15: 'Les organismes fournissant données et informations sismologiques dans la région',
      text16: 'Sismologie citoyenne en Haïti'
    }
  },
  en: {
    home: {
      eventlist1: 'Events in the study area (last 7 days)',
      eventlist2: 'Local time (America/Port-au-Prince)',
      infoTitle: 'Further information',
      info1_1: 'Automatic locations appear as a dotted square. As soon as a seismologist (currently the seismologists of the',
      info1_2: 'laboratory) has validated the earthquake, the location appears in the form of a circle.',
      info2: 'Reported events are those seen by the network. Outside the rectangle covering Haiti, the solutions can be very approximate and it is better to refer to neighboring national organizations, in particular for Santo Domingo.',
      info3_1: 'The data analyzed in real time',
      info3_2: 'are obtained from the seismological stations of several networks: the network of the S2RHAI project (network of',
      info3_3: 'stations installed in private homes or in schools), the network of the',
      info3_4: 'of Haiti and the networks of nearby countries (Cuba, Dominican Republic, Jamaica, Puerto Rico). The automatic detection software is',
      info3_5: 'developed by',
      info3_6: 'and by',
      info5_1: "Ayiti-Séismes is the result of a collaboration between URGéo laboratory of the Faculty of Sciences, the Bureau of Mines and Energy of Haiti, Géoazur laboratory of the Côte d'Azur University (France), Geology laboratory of the Ecole Normale Supérieure (Paris, France), Euro-Mediterranean Seismological Center (CSEM/EMSC), LAM laboratory (Les Afriques dans le Monde, CNRS/Sciences Po Bordeaux).",
      info5_2: 'Ayiti-Séismes is financially supported by the S2RHAI (CNRS - IRD), OSMOSE (Agence Nationale de la Recherche), CARIBACT (Laboratoire Mixte International, IRD), PREST (Interreg V Caraïbe, European Union) and USAID/USGS projects.',
      info6_1: 'This site, currently hosted at Géoazur, uses the seismological stations of the Bureau of Mines and Energy, those of neighboring countries, as well as "citizen" seismological stations Raspberry Shake (see',
      info6_2: ') to quickly locate earthquakes in and around Haiti. It therefore allows everyone to view seismic activity in Haiti in near real time.',
      info7: 'However, this brief information remains preliminary. Official information for Haiti is provided by the bulletin of the Bureau of Mines and Energy.'
    },
    nav: {
      home: 'Home',
      scientificData: 'Scientific data',
      catalog: 'Catalog',
      scientificalResults: 'Scientific results',
      fdsnws: 'FDSN webservices',
      station: 'Stations',
      info: 'Information',
      links: 'Links'
    },
    app: {
      geolocationTitle: 'Geolocation',
      geolocationContent1: 'Activate geolocation allows you to benefit from additional tools:',
      geolocationContent2: 'list events based on your location',
      geolocationContent3: 'list stations based on your location',
      geolocationContent4: 'No personal data is communicated on the server.',
      yes: 'Yes',
      no: 'No',
      days: 'd',
      hours: 'h',
      minutes: 'm',
      seconds: 's'
    },
    event: {
      text1: 'Type',
      text2: 'Magnitude',
      text3: 'Date and time',
      text4: 'Latitude',
      text5: 'Longitude',
      text6: 'Depth',
      text7: 'Map',
      text8: 'Bulletin',
      text9: 'Stats',
      text10: 'Sismograms',
      text11: 'The seismological data distributed here is in SAC format.',
      text12: 'Authentication is required for their download.',
      text13: 'Download data'
    },
    catalog: {
      warn1: 'The fields are set from your previous request. You can reset the fields to their default values by clicking',
      warn2: 'here',
      form1: 'Dates',
      form2: 'Last days',
      form3: 'Start',
      form4: 'End',
      form5: 'Geographic area',
      form6: 'min',
      form7: 'max',
      form8: 'Latitude',
      form9: 'Longitude',
      form10: 'Event types',
      form11: 'any',
      form12: 'earthquake',
      form13: 'quarry blast',
      form14: 'explosion',
      form15: 'undefined',
      form16: 'Depth',
      form17: 'Magnitude',
      form18: 'Output format',
      form19: 'Submit',
      resultNav1: 'List',
      resultNav2: 'Map',
      resultNav3: 'Stats',
      resultList1: 'Results:',
      resultList2: 'events',
      result0: 'Request parameters',
      result1: 'min',
      result2: 'max'
    },
    map: {
      legend0: 'Legend',
      legend1: 'Magnitude',
      legend2: 'Event rating',
      legend3_1: 'automatic',
      legend3_2: 'Event detected automatically, not yet confirmed by the seismological service.',
      legend4_1: 'earthquake',
      legend4_2: 'The event is an earthquake, confirmed by the seismological service.',
      legend5_1: 'artificial',
      legend5_2: 'Anthropogenic event, confirmed by the seismological service.',
      disclaimer: 'The detection is automatic, and not necessarily validated by a seismologist.'
    },
    station: {
      list1: 'Latency',
      list2: 'stations with dayplot',
      list3: 'latency',
      panel1: 'Latitude',
      panel2: 'Longitude',
      panel3: 'Altitude',
      panel4: 'Map',
      panel5: 'Last earthquakes',
      panel6: 'Installation date',
      map1: 'Legend',
      map2: 'Latency'
    },
    links: {
      text1: 'Links',
      text2: 'The main partners',
      text3: 'The S2RHAIL project is funded by the CNRS and the IRD (joint action Natural Risks).',
      text4: 'Geosciences Research Unit, Faculty of Sciences of the State University of Haiti',
      text5: "Géoazur (about 170 people) is a Geosciences research laboratory which depends on the Côte d'Azur University, the CNRS (National Center for Scientific Research), the IRD (Research Institute for Development) and the Côte d'Azur Observatory. The seismological observatory of the laboratory is in charge of the seismological data produced in the South-East quarter of France within the framework of the RESIF project (French Seismological and Geodesic Network). The SEISMES team includes 16 permanent researchers and 18 doctoral and post-doctoral students who carry out cutting-edge research on understanding the processes at the origin of earthquakes and the ground movements they generate on the surface.",
      text6: 'Other project partners',
      text7: 'Bureau of Mines and Energy of Haiti',
      text8: 'CSEM-EMSC, Euro-Mediterranean Seismological Center',
      text9: 'Focused on the Mediterranean basin, this site also offers monitoring of global seismicity',
      text10: 'Department of Geosciences, ENS, PSL',
      text11: 'The Department of Geosciences of the Ecole Normale Supérieure (120 permanent staff) is a place of high-level research and teaching in planetary sciences backed by the Geology Laboratory and the Dynamic Meteorology Laboratory. It trains researchers in earth, ocean, atmospheric and biogeosciences. The Ecole Normale Supérieure is a partner of PSL University.',
      text12: "EDUMED (Université Côte d'Azur)",
      text13: 'EDUMED-Obs is an interface providing access to geoscience research data, and oriented towards natural risk education for the general public and schoolchildren. This educational observatory also aims to facilitate the use of data from sensors in secondary and higher education. Data from stations installed in Haiti can be accessed by',
      text14: "Master's degree in urban planning, development of territories at risk (Faculty of Sciences of the State University of Haiti).",
      text15: 'Organizations providing seismological data and information in the region',
      text16: 'Citizen Seismology in Haiti'
    }
  },
  ht: {
    home: {
      eventlist1: 'Evènman nan zòn etid la (7 dènye jou)',
      eventlist2: 'Tan nan tan lokal yo (America/Port-au-Prince)',
      infoTitle: 'Plis enfòmasyon',
      info1_1: 'Kote otomatik yo parèt tankou yon kare pwentiye. Le pli vit ke yon sismològ (aktyèlman sismològ laboratwa',
      info1_2: 'la) te valide tranblemanntè a, kote a parèt sou fòm yon sèk.',
      info2: 'Evènman rapòte yo se sa yo wè pa rezo a. Deyò rektang ki kouvri Ayiti a, solisyon yo ka trè apwoksimatif e li pi bon pou w refere ak òganizasyon nasyonal vwazen yo, sitou pou Sendomeng.',
      info3_1: 'Done yo analize an tan reyèl',
      info3_2: 'yo jwenn nan estasyon sismolojik plizyè rezo: rezo pwojè S2RHAI (rezo estasyon',
      info3_3: 'enstale nan kay prive oswa nan lekòl), rezo',
      info3_4: 'Ayiti ak rezo peyi ki toupre yo (Kiba, Repiblik Dominikèn, Jamayik, Pòtoriko). Lojisyèl deteksyon otomatik la se',
      info3_5: 'devlope pa',
      info3_6: 'ak',
      info4: 'Poukisa sit sa a?',
      info5: "Ayiti-Séisme se rezilta yon kolaborasyon ant Biwo Min ak Enèji, laboratwa URGéo Fakilte Syans yo, laboratwa Géoazur Inivèsite Côte d'Azur (Frans), laboratwa Jeoloji Ecole Normale Supérieure (Pari). , Frans) ak Sant Sismolojik Euro-Mediterane (CSEM/EMSC) ak laboratwa LAM (Les Afriques dans le Monde, CNRS/Sciences Po Bordeaux) nan kad pwojè S2RHAI (CNRS - IRD), pwojè OSMOSE (Rechèch Nasyonal). Ajans) ak Laboratwa Konjwen Entènasyonal CARIBACT (IRD, Inivèsite Leta Ayiti).",
      info6_1: 'Sit sa a, ki genyen kounye a nan Géoazur, sèvi ak estasyon sismolojik Biwo Min ak Enèji, sa yo ki nan peyi vwazen yo, ansanm ak estasyon sismolojik "sitwayen" Raspberry Shake (gade',
      info6_2: ') pou lokalize rapid tranblemanntè ann Ayiti ak anviwònman li yo. Se poutèt sa, li pèmèt tout moun wè aktivite sismik ann Ayiti nan prèske tan reyèl.',
      info7: 'Sepandan, enfòmasyon kout sa a rete preliminè. Enfòmasyon ofisyèl pou Ayiti se bilten Biwo Min ak Enèji.'
    },
    nav: {
      home: 'Akeyi',
      scientificData: 'Done syantifik',
      catalog: 'Katalòg',
      scientificalResults: 'Rezilta syantifik',
      fdsnws: 'Sèvis entènèt FDSN',
      station: 'Estasyon',
      info: 'Enfòmasyon',
      links: 'Koneksyon'
    },
    app: {
      geolocationTitle: 'Geolokalizasyon',
      geolocationContent1: 'Aktive jeolokalizasyon pèmèt ou benefisye de zouti adisyonèl:',
      geolocationContent2: 'lis evènman ki baze sou kote ou',
      geolocationContent3: 'lis estasyon ki baze sou kote ou',
      geolocationContent4: 'Pa gen okenn done pèsonèl kominike sou sèvè a.',
      yes: 'Wi',
      no: 'Non',
      days: 'j',
      hours: 'è',
      minutes: 'm',
      seconds: 's'
    },
    event: {
      text1: 'Kalite evènman yo',
      text2: 'Magnitude',
      text3: 'Dat ak lè',
      text4: 'Latitid',
      text5: 'Lonjitid',
      text6: 'Pwofondè',
      text7: 'Kat jeyografik',
      text8: 'Bilten',
      text9: 'Statistik',
      text10: 'Sismogram',
      text11: 'Done sismolojik yo distribiye isit la se nan fòma SAC.',
      text12: 'Otantifikasyon obligatwa pou telechaje yo.',
      text13: 'Telechaje done yo'
    },
    catalog: {
      warn1: 'Jaden yo mete kòm dènye demann ou an. Ou ka retounen nan rechèch default la lè w klike',
      warn2: 'isit',
      form1: 'Dat',
      form2: 'Dènye jou',
      form3: 'Kòmanse',
      form4: 'Fini',
      form5: 'Zòn jewografik',
      form6: 'min',
      form7: 'max',
      form8: 'Latitid',
      form9: 'Lonjitid',
      form10: 'Kalite evènman yo',
      form11: 'nenpòt',
      form12: 'tranbleman tè',
      form13: 'tire karyè',
      form14: 'eksplozyon',
      form15: 'endefini',
      form16: 'Pwofondè',
      form17: 'Magnitude',
      form18: 'Fòma',
      form19: 'soumèt',
      resultNav1: 'Lis',
      resultNav2: 'Kat jeyografik',
      resultNav3: 'Statistik',
      resultList1: 'Rezilta yo:',
      resultList2: 'evènman',
      result0: 'Anviwònman rechèch',
      result1: 'minim',
      result2: 'maksimòm'
    },
    map: {
      legend0: 'Lejand',
      legend1: 'Magnitude',
      legend2: 'Evalyasyon evènman',
      legend3_1: 'otomatik',
      legend3_2: 'Evènman detekte otomatikman, poko konfime pa sèvis sismolojik la.',
      legend4_1: 'tranbleman tè',
      legend4_2: 'Evènman an se yon tranblemanntè, ki konfime pa sèvis sismolojik la.',
      legend5_1: 'atifisyèl',
      legend5_2: 'Evènman antropojenik, konfime pa sèvis sismolojik la.',
      disclaimer: 'Deteksyon an se otomatik, epi li pa nesesèman valide pa yon sismologist.'
    },
    station: {
      list1: 'Latansi',
      list2: 'estasyon ak dayplot',
      list3: 'latansi',
      panel1: 'Latitid',
      panel2: 'Longitude',
      panel3: 'Altitid',
      panel4: 'kat jeyografik',
      panel5: 'Dènye tranblemanntè',
      map1: 'Lejand',
      map2: 'Latansi'
    },
    links: {
      text1: 'Koneksyon',
      text2: 'Patnè prensipal yo',
      text3: 'Pwojè S2RHAIL a finanse pa CNRS ak IRD (joint action Natural Risks).',
      text4: 'Inite Rechèch Jeosyans, Fakilte Syans Inivèsite Leta Ayiti',
      text5: "Géoazur (apeprè 170 moun) se yon laboratwa rechèch jeosyans ki depann de Inivèsite Côte d'Azur, CNRS (Sant Nasyonal pou Rechèch Syantifik), IRD (Enstiti Rechèch pou Devlopman) ak Obsèvatwa Côte d'Azur. Obsèvatwa sismolojik laboratwa a responsab done sismolojik ki pwodui nan trimès Sidès Lafrans nan kad pwojè RESIF (Rezo sismolojik ak jeodezi franse). Ekip SEISMES la gen ladann 16 chèchè pèmanan ak 18 etidyan doktora ak post-doktora ki fè rechèch dènye kri sou konpreyansyon pwosesis yo nan orijin tranblemanntè ak mouvman tè yo jenere sou sifas la.",
      text6: 'Lòt patnè pwojè yo',
      text7: 'Biwo Min ak Enèji Ayiti',
      text8: 'CSEM-EMSC, Sant Sismolojik Euro-Mediterane',
      text9: 'Konsantre sou basen Mediterane a, sit sa a ofri tou siveyans sismisite mondyal la',
      text10: 'Depatman Jeosyans, ENS, PSL',
      text11: 'Depatman Jeosyans nan Ecole Normale Supérieure (120 anplwaye pèmanan) se yon kote nan rechèch wo nivo ak ansèyman nan syans planetè te sipòte pa Laboratwa Jeoloji ak Laboratwa Meteyoloji Dinamik. Li fòme chèchè nan latè, oseyan, atmosferik ak byojeosyans. Ecole Normale Supérieure se yon patnè nan PSL University.',
      text12: 'EDUMED (University of French Riviera)',
      text13: 'EDUMED-Obs se yon koòdone ki bay aksè a done rechèch jeosyans, ak oryante nan edikasyon risk natirèl pou piblik la an jeneral ak timoun lekòl yo. Obsèvatwa edikasyon sa a tou gen pou objaktif pou fasilite itilizasyon done ki soti nan detèktè nan edikasyon segondè ak siperyè. Ou ka jwenn done ki soti nan estasyon ki enstale ann Ayiti nan',
      text14: 'Mèt planifikasyon iben, devlopman teritwa a risk (Fakilte Syans Inivèsite Leta Ayiti).',
      text15: 'Òganizasyon ki bay done ak enfòmasyon sismolojik nan rejyon an'
    }
  }
}
